import { AxiosResponse, AxiosError } from 'axios';
import axios from '../../app/requests/axios';
import IApiResponse from '../../models/requests/apiResponse';

interface IChangePasswordResponseUserData {
    msg: string;
};

interface IPasswordPayload {
    clientId: string;
    payload: {
      oldPassword: string;
      newPassword: string;
    }
};

const ChangePasswordApi = async (passwordPayload: IPasswordPayload): Promise<IApiResponse<IChangePasswordResponseUserData>> => {
  return await axios.patch(`/clients/auth/password/${passwordPayload.clientId}`, passwordPayload.payload)
    .then((response: AxiosResponse<IApiResponse<IChangePasswordResponseUserData>>) => {
      return response.data;
    })
    .catch((error: AxiosError) => {
      if (error.response) {
        return error.response.data;
      }
      return {
        status: false,
        code: '0',
        errors: [{
          param: 'Network Error',
          msg: 'Check your network connection then try again!'
        }
        ]
      };
    }
    );
};

export default ChangePasswordApi;
